import { useNavigate } from 'react-router-dom';
import { ArrowRight, Shapes } from 'lucide-react';

const SHAPES_BG = 'https://static.prod-images.emergentagent.com/jobs/0e7ec82b-be21-4167-ae09-299c58207254/images/b2f79a00e3e7026c8cc3c707837c5f6bc69c299688fbfbcfe5b474f82206f985.png';

export default function ShapesHomePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6" style={{ backgroundImage: `url(${SHAPES_BG})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'fixed' }}>
      <div className="bg-white/95 backdrop-blur-md border-4 border-white rounded-3xl shadow-2xl p-8 sm:p-10 max-w-md w-full text-center">
        {/* Shape icons */}
        <div className="flex justify-center gap-3 mb-4">
          <div className="w-12 h-12 rounded-full bg-red-500 shadow-md" />
          <div className="w-12 h-12 bg-blue-500 rounded shadow-md" />
          <div className="w-0 h-0 border-l-[24px] border-r-[24px] border-b-[42px] border-l-transparent border-r-transparent border-b-amber-500 mt-1" />
        </div>

        <h1 className="font-heading text-4xl sm:text-5xl font-black text-gray-900 mb-2">
          Guess the Shape!
        </h1>
        <p className="font-body text-base text-gray-600 mb-6 leading-relaxed">
          Can you name the shapes? Look at the colourful shape and pick the right answer!
        </p>

        <div className="flex justify-center gap-3 mb-6">
          <span className="bg-pink-50 text-pink-600 text-xs font-bold px-3 py-1.5 rounded-full">
            5 Questions
          </span>
          <span className="bg-blue-50 text-blue-600 text-xs font-bold px-3 py-1.5 rounded-full">
            Basic Shapes
          </span>
        </div>

        <button
          data-testid="start-shapes"
          onClick={() => navigate('/shapes/play')}
          className="bg-gradient-to-r from-pink-500 to-violet-500 text-white font-black text-xl py-4 px-10 rounded-full border-b-[6px] border-violet-700 active:border-b-0 active:translate-y-[6px] transition-all hover:from-pink-400 hover:to-violet-400 flex items-center gap-3 mx-auto shadow-lg"
        >
          Let&apos;s Go!
          <ArrowRight className="w-6 h-6" />
        </button>

        <button
          data-testid="shapes-back-studio"
          onClick={() => navigate('/')}
          className="mt-5 text-gray-500 font-bold text-sm hover:text-gray-800 transition-colors underline"
        >
          Back to Studio
        </button>
      </div>
    </div>
  );
}
